import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {Translate} from 'react-redux-i18n';
import * as snackbarsActions from '../../../../actions/snackbars';
import documentReminderService from '../../../../services/documentReminder/DocumentReminderService';
import {captureError} from '../../../../utils/log';
import ReminderView from './ReminderView';

function ReminderContainer(props) {
  const organisation = useSelector(state => state.organisation);
  const globalDispatch = useDispatch();
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const {subcontractorId} = useParams();
  const aborter = new AbortController();

  React.useEffect(() => {
    function removeEvent() {
      setIsOpen(false);
    }

    document.addEventListener('closeReminders', removeEvent);
    return () => {
      document.removeEventListener('closeReminders', removeEvent);
      aborter.abort();
    };
  }, []);

  function handleOpenReminder() {
    if (!isOpen) {
      // Send an event to close the potentially other open reminder
      document.dispatchEvent(new Event('closeReminders'));
    }

    setIsOpen(current => !current);

    if (!loading && !documents.length) {
      setLoading(true);

      documentReminderService.getDocumentsByReminder(props.reminder.id, subcontractorId, organisation.organisationId, aborter.signal)
        .then(response => {
          const docs = response.map(document => {
            // Attach reminded document state to each document
            const remindedState = props.reminder.documents
              .find(doc => doc.correlationId === document.correlationId)
              .documentState;

            return {
              ...document,
              remindedState
            };
          });

          setDocuments(docs);
        })
        .catch(error => {
          captureError('Error while getting documents from a specific reminder', error);
          globalDispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
        })
        .finally(() => setLoading(false));
    }
  }

  return (
    <ReminderView
      reminder={props.reminder}
      documents={documents}
      isOpen={isOpen}
      loading={loading}
      onOpenReminder={handleOpenReminder}
    />
  );
}

ReminderContainer.propTypes = {
  reminder: PropTypes.object.isRequired
};

export default ReminderContainer;
